import React, { useEffect, useState } from 'react';
import { useAuth } from "../hooks/useAuth";
import '../css/landingPageStylings/HeroCardStylings.css';
import {useNavigate} from "react-router-dom";
import VineAnimation from '../components/reusableComponents/VineAnimation';

const HeroCard = ({
                      title = "🌱 Planted",
                      subtitle = "Design your dream garden with our intelligent planning tools. From seed to harvest, we've got you covered.",
                      buttonText = "Start Growing Today",
                      onButtonClick = () => {},
                      className = "",
                      isLoggedIn=false,
                      user
                  }) => {
    // const { user, isLoggedIn } = useAuth();

    const [welcomeText, setWelcomeText] = useState([title, subtitle, buttonText]);
    const navigate = useNavigate();

    const handleDashboardNavigate = () => {
        navigate('/dashboard');
    }

    useEffect(() => {
        if (user && isLoggedIn && welcomeText[0] === title) {
            const welcomeList = [
                [`🐝 Buzzing with joy to see you again ${user.given_name}!`, `Your plants have been gossiping… they missed you.`, `Return to Your Roots`],
                [`🌼 Glad to see you blooming ${user.given_name}!`, `Sunshine, seeds, and you. Let's grow!`, `Plant Something New`],
                [`👋 Welcome back ${user.given_name}!`, `Your green space awaits—let's bring your ideas to life.`, `Start Planning`],
                [`🌄 Let's grow something beautiful today, ${user.given_name}!`, `The garden party doesn't start without you.`, `Let's Get Growing`],
                [`🌞 Bright days and green things ahead, ${user.given_name}!`, `From seedling to harvest, we're with you every step of the way.`, `See What's Blooming`],
                [`🧑‍🌾 Ready to get your hands dirty again, ${user.given_name}?`, `Welcome back to your garden sanctuary. Let's see what's sprouting!`, `Back to the Garden`],
                [`🍃 Back to the garden grind ${user.given_name}!`, `The soil is ready, and your plants missed you!`, `Sprout New Ideas`],
                [`🪴 Hey there, plant lover!`, `Your digital garden helper is happy to see you again!`, `Rejoin the Garden`]
            ];
            const random = Math.floor(Math.random() * welcomeList.length);
            setWelcomeText(welcomeList[random]);
        }
    }, [user, isLoggedIn]);

    return (
        <div className={`hero-card ${className}`}>
            <div className="floating-elements">
                <div className="floating-leaf"></div>
                <div className="floating-leaf"></div>
                <div className="floating-leaf"></div>
            </div>

            <div className="hero-content">
                <h1 className="hero-title">{welcomeText[0]}</h1>
                <p className="hero-subtitle">{welcomeText[1]}</p>
                <button className="hero-button" onClick={onButtonClick}>
                    {welcomeText[2]}
                </button>
                {isLoggedIn && (
                    <button className="hero-button" onClick={handleDashboardNavigate}>
                        Dashboard
                    </button>
                )}
            </div>

            <VineAnimation
                animationInterval={15000}
                enableMobileVersion={true}
                mobileBreakpoint={768}
            />

            {/*<div className="supplemental-vine-test">*/}
            {/*    <Vine3 className="vine-path"/>*/}
            {/*</div>*/}
        </div>
    );
};

export default HeroCard;